import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import {
  faGithub,
  faLinkedin,
  faMedium,
  faStackOverflow,
} from "@fortawesome/free-brands-svg-icons";
import { Box, HStack } from "@chakra-ui/react";

const socials = [
  {
    icon: faEnvelope,
    url: "mailto: hello@bonstudio.io",
  },
  // {
  //   icon: faGithub,
  //   url: "https://github.com",
  // },
  // {
  //   icon: faLinkedin,
  //   url: "https://www.linkedin.com",
  // },
  // {
  //   icon: faMedium,
  //   url: "https://medium.com",
  // },
  // {
  //   icon: faStackOverflow,
  //   url: "https://stackoverflow.com",
  // },
];

const Header = () => {
  const handleClick = (e, anchor) => { 
    e.preventDefault(); 
    console.log(anchor);
    const id = `${anchor}-section`;
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  return (
    <Box
      position="fixed"
      top={0}
      left={0}
      right={0}
      translateY={0}
      transitionProperty="transform"
      transitionDuration=".3s"
      transitionTimingFunction="ease-in-out"
      backgroundColor="#18181b"
    >
      <Box color="white" maxWidth="1280px" margin="0 auto">
        <HStack
          px={16}
          py={4}
          justifyContent="space-between"
          alignItems="center"
        >
          <nav>
            {/* Social media links do not need onClick. */}
            <HStack spacing={4}>
              {socials.map((link, index) => {
                return (
                  <a key={index} href={link.url} target="_blank" rel="noopener noreferrer">
                    <FontAwesomeIcon icon={link.icon} size="2x" />
                  </a>
                )
              })}
            </HStack>
          </nav>
          <nav>
            <HStack spacing={8}>
              <a href="#projects-section" onClick={(e) => handleClick(e, "projects")}>Clients</a>
              <a href="#contactme-section" onClick={(e) => handleClick(e, "contactme")}>Contact Us</a>
            </HStack>
          </nav>
        </HStack>
      </Box>
    </Box>
  );
};

export default Header;
